import React from 'react';

const Footer = props => {
    const year = new Date()
    return (
        <footer className="text-center text-muted footer">
            <p> ©{year.getFullYear()} Catoro by ArtesanoSpirit <br></br>
            <small><a href="http://github.com/fbohz/" target="_blank" rel="noopener noreferrer">Misguided Apps</a> | <a href="https://raw.githubusercontent.com/fbohz/catoro-frontend/master/privacy_policy.md" target="_blank" rel="noopener noreferrer">Privacy Policy</a></small> </p> 
      </footer> 
    )
}

export default Footer
